import * as React from 'react';
import { Button, ModalWindow, UIText2, useToast } from '@cian/ui-kit';

import { useApplicationContext } from 'shared/utils/applicationContext';
import { fetchAcceptRealEstate } from 'shared/repositories/cian-dobro/v1/accept-real-estate';
import { fetchDeclineRealEstate } from 'shared/repositories/cian-dobro/v1/decline-real-estate';

import styles from './DobroListingApplicationProcessingButton.css';

interface IProps {
  type: 'apply' | 'decline';
  offerId: number;
  reloadOffers(): void;
}

export const DobroListingApplicationProcessingButton = (props: IProps) => {
  const { type, offerId, reloadOffers } = props;

  const isApplyAction = type === 'apply';

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const { httpApi } = useApplicationContext();

  const toastApi = useToast();

  const openModal = React.useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const closeModal = React.useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const showErrorToast = React.useCallback(() => {
    toastApi.open({ type: 'error', text: 'Что-то пошло не так, попробуйте ещё раз' });
  }, [toastApi]);

  const handleSubmit = React.useCallback(async () => {
    try {
      setIsLoading(true);

      const action = isApplyAction ? fetchAcceptRealEstate : fetchDeclineRealEstate;
      const r = (await action({ httpApi, parameters: { id: offerId } })) as { statusCode: number };

      if (r?.statusCode !== 200) {
        showErrorToast();

        return;
      }

      reloadOffers();
      closeModal();
    } catch {
      showErrorToast();
    } finally {
      setIsLoading(false);
    }
  }, [closeModal, httpApi, isApplyAction, offerId, reloadOffers, showErrorToast]);

  return (
    <>
      <ModalWindow open={isModalOpen} onClose={closeModal}>
        <div className={styles.wrapper}>
          <UIText2 fontWeight="600">{isApplyAction ? 'Хотите взять заявку в работу?' : 'Отменить заявку?'}</UIText2>

          <Button loading={isLoading} onClick={handleSubmit}>
            Подтвердить
          </Button>
        </div>
      </ModalWindow>

      <Button
        fullWidth
        loading={isLoading}
        theme={isApplyAction ? 'fill_success_secondary' : 'fill_error_secondary'}
        onClick={openModal}
      >
        {isApplyAction ? 'Взять в работу' : 'Отказаться'}
      </Button>
    </>
  );
};
